export type DocumentComparisonFileTypes = 'doc' | 'docx' | 'pdf';
export interface DocDetails {
    base64: string;
    type: DocumentComparisonFileTypes;
}

export const MIME_TYPE_BY_FILE_EXTENSION = {
    doc: 'msword',
    docx: 'msword',
    pdf: 'pdf'
}